import { GuideStep, StepType } from '../guide';
import { v4 } from 'uuid';

export const generateStep = (
  type: StepType,
  amount: string,
  unit: string,
  duration: number,
): GuideStep => {
  return {
    type,
    amount: parseFloat(amount),
    id: v4(),
    name: defaultInstruction(type, parseFloat(amount), unit, duration),
    description_text: null,
    image_identifier: null,
    amount_unit: unit,
    time_at: 0,
    time_duration: duration,
  };
};

export const defaultInstruction = (
  type: StepType,
  amount: number,
  unit: string,
  duration: number,
): string => {
  switch (type) {
    case StepType.grind:
      return `Grind ${amount}${unit} of coffee`;
    case StepType.boil:
      return `Boil ${amount}ml of water`;
    case StepType.prepare:
      return 'Prepare the following';
    case StepType.wait:
      return `Wait for ${duration} seconds`;
    case StepType.stir:
      return `Stir for ${duration} seconds`;
    case StepType.pour:
      return `Pour ${amount}${unit} of water`;
    case StepType.bloom:
      return `Pour ${amount}${unit} of water and wait to bloom`;
  }
};
